export default __webpack_public_path__ + "img/flkyevEi.6e6f8941.svg";